import { UpdateLinkedGroupsParams } from '@/domain/models/LinkItem';
import { errorHandler } from '@/lib/ErrorHandler';
import { getClient } from '@/lib/restClient';
import { LinkedGroupService } from '@/services/LinkedGroup';

export const useUpdateLinkedGroup = async (
  params: UpdateLinkedGroupsParams
): Promise<void> => {
  const linkedGroupService = new LinkedGroupService(getClient());

  return linkedGroupService
    .put(params)
    .catch((error: Error) => errorHandler({ error }));
};
